module.exports = __webpack_public_path__ + "static/media/mo.e1178856.svg";